'use client';

import { useTranslations } from 'next-intl';

import { Error as ErrorSection } from '@/vibes/mom/sections/error';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ reset }: Props) {
  const t = useTranslations('Error');

  const handleReset = () => {
    reset();
    // Fallback: reload the page if reset doesn't work
    window.location.reload();
  };

  return (
    <ErrorSection
      ctaAction={handleReset}
      ctaLabel={t('cta')}
      subtitle={t('subtitle')}
      title={t('title')}
    />
  );
}
